import React from 'react'

import Icon from '@/components/common/Icon'

const IconYoutube: React.FC<{
  className?: string
  width?: number
  height?: number
}> = ({ className, width, height }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 32 33"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <g clipPath="url(#clip0_279_1400)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 32.5C24.8366 32.5 32 25.3366 32 16.5C32 7.66344 24.8366 0.5 16 0.5C7.16344 0.5 0 7.66344 0 16.5C0 25.3366 7.16344 32.5 16 32.5ZM26.9588 11.0043C26.6952 10.0252 25.9231 9.25318 24.944 8.98957C23.1552 8.5 15.9999 8.5 15.9999 8.5C15.9999 8.5 8.84468 8.5 7.05587 8.97074C6.09556 9.23435 5.30471 10.0252 5.0411 11.0043C4.57036 12.7932 4.57036 16.5026 4.57036 16.5026C4.57036 16.5026 4.57036 20.2309 5.0411 22.0008C5.30471 22.98 6.07673 23.752 7.05587 24.0156C8.86351 24.5052 15.9999 24.5052 15.9999 24.5052C15.9999 24.5052 23.1552 24.5052 24.944 24.0344C25.9231 23.7708 26.6952 22.9988 26.9588 22.0197C27.4295 20.2309 27.4295 16.5214 27.4295 16.5214C27.4295 16.5214 27.4483 12.7932 26.9588 11.0043ZM13.7216 19.9296L19.6717 16.5026L13.7216 13.0756V19.9296Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_279_1400">
        <rect y="0.5" width="32" height="32" rx="16" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
)

export default Icon(IconYoutube)
